export default __webpack_public_path__ + "5db7c8d7aee1fc899553481b95cddeb3.png";